import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import api from "../../services/api";
import jalaali from "jalaali-js"; 
import { useTasks } from "../../context/TasksContext"; 

export default function PanelTabs() {
  
  const { refreshTasks } = useTasks();

  // --- تاریخ امروز (پیش‌فرض) ---
  const today = new Date();
  const jToday = jalaali.toJalaali(today);
  const todayString = `${jToday.jy}/${String(jToday.jm).padStart(2, '0')}/${String(jToday.jd).padStart(2, '0')}`;

  // =========================================================================
  // 1. STATE MANAGEMENT
  // =========================================================================

  // --- فرم ثبت کار ---
  const [workForm, setWorkForm] = useState({
    title: "",
    project: "", 
    projectName: "انتخاب کنید",
    
    // --- فیلدهای مربوط به نوع کار ---
    taskTypeId: "", 
    taskTypeLabel: "انتخاب کنید",
    estimatedMinutes: "", // این فقط وقتی پر می‌شود که "سایر" انتخاب شود
    isCustomTime: false,  // آیا گزینه انتخاب شده نیاز به زمان دستی دارد؟
    // -------------------

    description: "",
    date: todayString, 
    userName: "در حال دریافت...",
  });

  // --- فرم ثبت درخواست ---
  const [requestForm, setRequestForm] = useState({
    typeId: "",             
    typeLabel: "انتخاب کنید", 
    selectedTypeObj: null,  
    fromDate: todayString,
    toDate: todayString,
    fromTime: "08:00",
    toTime: "17:00",
    amount: "",
    description: ""
  });

  const [requestTypes, setRequestTypes] = useState([]);
  const [projects, setProjects] = useState([]);
  const [taskTypes, setTaskTypes] = useState([]); 
  
  // --- مدیریت مودال ---
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [editingField, setEditingField] = useState(""); 
  const [inputValue, setInputValue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // متغیر کمکی برای زمان دستی داخل مودال
  const [customTimeInput, setCustomTimeInput] = useState("");

  // متغیرهای تاریخ مودال
  const [modalYear, setModalYear] = useState("");
  const [modalMonth, setModalMonth] = useState("");
  const [modalDay, setModalDay] = useState("");
  const [modalHour, setModalHour] = useState("");
  const [modalMinute, setModalMinute] = useState("");

  const [toast, setToast] = useState({ show: false, message: "", type: "success" });

  // =========================================================================
  // 2. EFFECTS & FETCH
  // =========================================================================

  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => setToast(prev => ({ ...prev, show: false })), 10000);
      return () => clearTimeout(timer);
    }
  }, [toast.show]);

  const showToast = (message, type = "success") => setToast({ show: true, message, type });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const projRes = await api.get("projects/");
        setProjects(projRes.data);

        const profileRes = await api.get("profile/");
        if (profileRes.data && profileRes.data.length > 0) {
            const fullName = profileRes.data[0].user_info.full_name || "کاربر";
            setWorkForm(prev => ({ ...prev, userName: fullName }));
        }

        const reqTypesRes = await api.get("request-types/"); 
        setRequestTypes(reqTypesRes.data);

        const taskTypesRes = await api.get("task-types/");
        setTaskTypes(taskTypesRes.data);

      } catch (error) { console.error(error); }
    };
    fetchData();
  }, []);

  // =========================================================================
  // 3. MODAL LOGIC
  // =========================================================================

  const openEditModal = (field, title, currentValue) => {
    setEditingField(field);
    setModalTitle(title);
    setShowModal(true);
    setCustomTimeInput(""); // ریست کردن ورودی زمان دستی

    if (field.includes("Date") || field === "workDate") {
        if (currentValue) {
            const [y, m, d] = currentValue.split("/").map(Number);
            setModalYear(y); setModalMonth(m); setModalDay(d);
        }
    } 
    else if (field.includes("Time")) {
        if (currentValue) {
            const [h, m] = currentValue.split(":").map(Number);
            setModalHour(h); setModalMinute(m);
        }
    } 
    else {
        setInputValue(currentValue || "");
    }
  };

  const handleSaveField = (e) => {
    e.preventDefault();
    
    // --- ذخیره فیلدهای ثبت کار ---
    if (editingField === "workProject") {
        const selectedProj = projects.find(p => p.id === parseInt(inputValue));
        setWorkForm(prev => ({ ...prev, project: inputValue, projectName: selectedProj?.title || "انتخاب کنید" }));
    }
    // *** لاجیک هوشمند نوع فعالیت ***
    else if (editingField === "workTaskType") {
        const selectedTask = taskTypes.find(t => t.id === parseInt(inputValue));
        
        if (selectedTask) {
            // اگر زمان استاندارد 0 بود (یعنی گزینه "سایر")
            if (selectedTask.standard_duration === 0) {
                // اگر کاربر زمانی وارد نکرده بود خطا نده، ولی بهتر است پر کند
                const userTime = customTimeInput || "0"; 
                setWorkForm(prev => ({ 
                    ...prev, 
                    taskTypeId: inputValue, 
                    taskTypeLabel: `${selectedTask.title} (${userTime} دقیقه)`,
                    estimatedMinutes: userTime,
                    isCustomTime: true
                }));
            } else {
                // فعالیت استاندارد
                setWorkForm(prev => ({ 
                    ...prev, 
                    taskTypeId: inputValue, 
                    taskTypeLabel: `${selectedTask.title} (${selectedTask.standard_duration} دقیقه)`,
                    estimatedMinutes: selectedTask.standard_duration,
                    isCustomTime: false
                }));
            }
        }
    }
    
    else if (editingField === "workDate") {
        const formattedDate = `${modalYear}/${String(modalMonth).padStart(2, '0')}/${String(modalDay).padStart(2, '0')}`;
        setWorkForm(prev => ({ ...prev, date: formattedDate }));
    }
    else if (editingField === "workTitle") setWorkForm(prev => ({ ...prev, title: inputValue }));
    else if (editingField === "workDescription") setWorkForm(prev => ({ ...prev, description: inputValue }));

    // --- ذخیره فیلدهای ثبت درخواست ---
    else if (editingField === "requestType") {
        const selectedType = requestTypes.find(t => t.id === parseInt(inputValue));
        setRequestForm(prev => ({ 
            ...prev, 
            typeId: inputValue, 
            typeLabel: selectedType?.title || "انتخاب کنید",
            selectedTypeObj: selectedType 
        }));
    }
    else if (editingField === "requestAmount") {
        setRequestForm(prev => ({ ...prev, amount: inputValue }));
    }
    else if (editingField === "requestDescription") {
        setRequestForm(prev => ({ ...prev, description: inputValue }));
    }
    else if (editingField.includes("Date")) { 
        const formattedDate = `${modalYear}/${String(modalMonth).padStart(2, '0')}/${String(modalDay).padStart(2, '0')}`;
        const key = editingField.replace("request", ""); 
        const stateKey = key.charAt(0).toLowerCase() + key.slice(1); 
        setRequestForm(prev => ({ ...prev, [stateKey]: formattedDate }));
    }
    else if (editingField.includes("Time")) { 
        const formattedTime = `${String(modalHour).padStart(2,'0')}:${String(modalMinute).padStart(2,'0')}`;
        const key = editingField.replace("request", ""); 
        const stateKey = key.charAt(0).toLowerCase() + key.slice(1);
        setRequestForm(prev => ({ ...prev, [stateKey]: formattedTime }));
    }

    setShowModal(false);
  };

  // =========================================================================
  // 4. SUBMIT
  // =========================================================================

  const handleSubmitWorkLog = async () => {
    if (isSubmitting) return;

    if (!workForm.title || !workForm.project || !workForm.taskTypeId) { 
        showToast("عنوان، پروژه و نوع فعالیت الزامی است", "error"); 
        return; 
    }
    
    setIsSubmitting(true);
    
    try {
        const [y, m, d] = workForm.date.split("/").map(Number);
        const gDate = jalaali.toGregorian(y, m, d);
        const dateForApi = `${gDate.gy}-${String(gDate.gm).padStart(2, '0')}-${String(gDate.gd).padStart(2, '0')}`;
        
        const payload = {
            title: workForm.title,
            project: workForm.project,
            description: workForm.description,
            start_time: `${dateForApi}T09:00:00`,
            task_type: workForm.taskTypeId,
            estimated_minutes: workForm.isCustomTime ? workForm.estimatedMinutes : 0
        };

        await api.post("work-logs/", payload);

        refreshTasks(); 
        showToast("کار جدید ثبت شد ", "success");
        document.documentElement.classList.remove("open-add-to-card");
        
        setWorkForm(prev => ({ 
            ...prev, 
            title: "", 
            description: "", 
            taskTypeId: "", 
            taskTypeLabel: "انتخاب کنید",
            estimatedMinutes: "",
            isCustomTime: false
        })); 
    } catch (error) { 
        showToast("خطا در ثبت کار", "error"); 
    } finally {
        setIsSubmitting(false);
    }
  };

  const handleSubmitRequest = async () => {
    
    if (isSubmitting) return;

    const { typeId, selectedTypeObj, amount, fromDate, toDate, fromTime, toTime, description } = requestForm;

    if (!typeId) { showToast("نوع درخواست را انتخاب کنید", "error"); return; }
    
    setIsSubmitting(true);

    const payload = {
        request_type: typeId,
        description: description || "",
    };

    if (selectedTypeObj.has_amount) {
        if (!amount) { showToast("مبلغ را وارد کنید", "error"); return; }
        setIsSubmitting(false);
        payload.amount = amount;
    }

    const convertToIso = (dateStr, timeStr) => {
         const [y, m, d] = dateStr.split("/").map(Number);
         const gDate = jalaali.toGregorian(y, m, d);
         return `${gDate.gy}-${String(gDate.gm).padStart(2, '0')}-${String(gDate.gd).padStart(2, '0')}T${timeStr}:00`;
    };

    if (selectedTypeObj.has_time_range) {
        payload.from_date = convertToIso(fromDate, fromTime);
        payload.to_date = convertToIso(fromDate, toTime); 
    } 
    else if (selectedTypeObj.has_date_range) {
        payload.from_date = convertToIso(fromDate, "08:00");
        payload.to_date = convertToIso(toDate, "17:00");
    } 
    else {
        const now = new Date().toISOString();
        payload.from_date = now;
        payload.to_date = now;
    }

    try {
        await api.post("requests/", payload);
        showToast("درخواست ثبت شد ", "success");
        document.documentElement.classList.remove("open-add-to-call");
        setRequestForm(prev => ({ ...prev, typeId: "", typeLabel: "انتخاب کنید", selectedTypeObj: null, amount: "", description: "" }));
    } catch (error) {
        console.error(error);
        showToast("خطا در ثبت درخواست", "error");
    } finally {
        setIsSubmitting(false);
    }
  };

  // =========================================================================
  // 5. RENDER
  // =========================================================================

  return (
    <>
      <div className="container">
        <div className="row p-full">
          <div className="col-12">
            <div className="tab-wrapper">
              <NavLink to="/" end className={({ isActive }) => (isActive ? "active" : "")}>
                <svg><use xlinkHref="#dashbordIcon" /></svg> داشبورد
              </NavLink>
              <NavLink to="/task-list" className={({ isActive }) => (isActive ? "active" : "")}>
                <svg><use xlinkHref="#listIcon" /></svg> لیست کارها
              </NavLink>
              <button id="addToCard" type="button"><svg><use xlinkHref="#taskIcon" /></svg> ثبت کار</button>
              <button id="addToCall" type="button"><svg><use xlinkHref="#taskIcon" /></svg> ثبت درخواست</button>
            </div>
          </div>
        </div>
      </div>

      {/* --- پنل کشویی ثبت کار --- */}
      <div className="add-to-card">
        <section>
          <h2>ثبت کار</h2>
          <button className="add-to-card-close" type="button"><svg><use xlinkHref="#arrowLeftIcon" /></svg></button>
        </section>
        <div className="form-add-to-card">
          <button type="button" onClick={() => openEditModal("workTitle", "عنوان کار", workForm.title)}>
            عنوان <span>{workForm.title || "وارد کنید..."}</span>
          </button>
          
          <button type="button" onClick={() => openEditModal("workProject", "انتخاب پروژه", workForm.project)}>
            پروژه <span>{workForm.projectName}</span>
          </button>

          <button type="button" style={{pointerEvents:"none",opacity:"0.5"}}>
            کاربر <span>{workForm.userName}</span>
          </button>

          {/* --- دکمه نوع فعالیت (ادغام شده) --- */}
          <button type="button" onClick={() => openEditModal("workTaskType", "نوع فعالیت", workForm.taskTypeId)}>
            نوع فعالیت <span>{workForm.taskTypeLabel}</span>
          </button>
          
          <button type="button" onClick={() => openEditModal("workDate", "تاریخ انجام", workForm.date)}>
            تاریخ <span>{workForm.date}</span>
          </button>
          
          <button type="button" onClick={() => openEditModal("workDescription", "توضیحات", workForm.description)}>
            توضیحات <span>{workForm.description || "خالی"}</span>
          </button>
          
          <div className="save-add-to-card">
            <button 
                type="button" 
                onClick={handleSubmitWorkLog}
                disabled={isSubmitting}
                style={{ opacity: isSubmitting ? 0.7 : 1, cursor: isSubmitting ? "not-allowed" : "pointer" }}
            >
                {isSubmitting ? "در حال ثبت..." : "ثبت کار جدید"}
            </button>
          </div>
        </div>
      </div>

      {/* --- پنل کشویی ثبت درخواست (بدون تغییر) --- */}
      <div className="add-to-call">
        <section>
          <h2>ثبت درخواست</h2>
          <button className="add-to-call-close" type="button"><svg><use xlinkHref="#arrowLeftIcon" /></svg></button>
        </section>
        
        <div className="form-add-to-call">
           
           <button type="button" onClick={() => openEditModal("requestType", "نوع درخواست", requestForm.typeId)}>
                نوع درخواست 
                <span>{requestForm.typeLabel}</span>
           </button>

           {requestForm.selectedTypeObj && (
               <>
                   {requestForm.selectedTypeObj.has_amount && (
                       <button type="button" onClick={() => openEditModal("requestAmount", "مبلغ (تومان)", requestForm.amount)}>
                           مبلغ <span>{requestForm.amount ? `${requestForm.amount} تومان` : "وارد کنید..."}</span>
                       </button>
                   )}

                   {requestForm.selectedTypeObj.has_time_range && (
                        <>
                            <button type="button" onClick={() => openEditModal("requestFromDate", "تاریخ", requestForm.fromDate)}>
                                تاریخ <span>{requestForm.fromDate}</span>
                            </button>
                            <div style={{display:'flex', gap:'10px'}}>
                                <button type="button" onClick={() => openEditModal("requestFromTime", "ساعت شروع", requestForm.fromTime)}>
                                    از ساعت <span>{requestForm.fromTime}</span>
                                </button>
                                <button type="button" onClick={() => openEditModal("requestToTime", "ساعت پایان", requestForm.toTime)}>
                                    تا ساعت <span>{requestForm.toTime}</span>
                                </button>
                            </div>
                        </>
                   )}

                   {(requestForm.selectedTypeObj.has_date_range && !requestForm.selectedTypeObj.has_time_range) && (
                        <>
                            <button type="button" onClick={() => openEditModal("requestFromDate", "از تاریخ", requestForm.fromDate)}>
                                از تاریخ <span>{requestForm.fromDate}</span>
                            </button>
                            <button type="button" onClick={() => openEditModal("requestToDate", "تا تاریخ", requestForm.toDate)}>
                                تا تاریخ <span>{requestForm.toDate}</span>
                            </button>
                        </>
                   )}
                   
                   {requestForm.selectedTypeObj.has_description && (
                       <button type="button" onClick={() => openEditModal("requestDescription", "توضیحات", requestForm.description)}>
                            توضیحات <span>{requestForm.description || "خالی"}</span>
                       </button>
                   )}
               </>
           )}

           <div className="save-add-to-call">
            <button 
              type="button" 
              onClick={handleSubmitRequest}
              disabled={isSubmitting}
              style={{ opacity: isSubmitting ? 0.7 : 1, cursor: isSubmitting ? "not-allowed" : "pointer" }}
            >
              {isSubmitting ? "در حال ارسال..." : "ثبت درخواست"}
            </button>
          </div>
        </div>
      </div>

      {/* --- مودال هوشمند مشترک --- */}
      {showModal && (
        <div className="edit-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) setShowModal(false); }}>
          <div className="edit-modal-content">
            <div className="edit-modal-header">
              <h3>{modalTitle}</h3>
              <button onClick={() => setShowModal(false)} className="close-modal-btn">&times;</button>
            </div>
            
            <form onSubmit={handleSaveField}>
              <div className="edit-modal-body">
                
                {editingField === "workProject" ? (
                    <select className="modal-input" value={inputValue} onChange={(e) => setInputValue(e.target.value)}>
                        <option value="">انتخاب کنید...</option>
                        {projects.map(p => <option key={p.id} value={p.id}>{p.title}</option>)}
                    </select>
                ) 
                
                // --- لاجیک انتخاب نوع فعالیت و زمان دستی در یک مودال ---
                : editingField === "workTaskType" ? (
                    <>
                        <select 
                            className="modal-input" 
                            value={inputValue} 
                            onChange={(e) => {
                                setInputValue(e.target.value);
                                // پاک کردن فیلد زمان دستی اگر گزینه تغییر کرد
                                setCustomTimeInput(""); 
                            }}
                        >
                            <option value="">انتخاب کنید...</option>
                            {taskTypes.map(t => (
                                <option key={t.id} value={t.id}>
                                    {t.title} {t.standard_duration > 0 ? `(${t.standard_duration} دقیقه)` : ""}
                                </option>
                            ))}
                        </select>

                        {/* اگر گزینه "سایر" انتخاب شد (که زمان استانداردش 0 است) */}
                        {taskTypes.find(t => t.id === parseInt(inputValue))?.standard_duration === 0 && (
                            <div style={{marginTop: '15px'}}>
                                <label style={{display:'block', marginBottom:'5px', fontSize:'0.9rem', color:'#666'}}>زمان مورد نیاز (دقیقه):</label>
                                <input 
                                    type="number" 
                                    className="modal-input" 
                                    value={customTimeInput} 
                                    onChange={e => setCustomTimeInput(e.target.value)} 
                                    placeholder="مثلاً 45"
                                    autoFocus
                                />
                            </div>
                        )}
                    </>
                )

                : editingField === "requestType" ? (
                    <select className="modal-input" value={inputValue} onChange={(e) => setInputValue(e.target.value)}>
                        <option value="">انتخاب کنید...</option>
                        {requestTypes.map(t => <option key={t.id} value={t.id}>{t.title}</option>)}
                    </select>
                )

                : (editingField.includes("Date") || editingField === "workDate") ? (
                    <div className="date-inputs-container">
                        <div className="date-field">
                            <label>روز</label>
                            <input type="number" className="modal-input date-input" value={modalDay} onChange={e=>setModalDay(e.target.value)} placeholder="DD"/>
                        </div>
                        <div className="date-field">
                            <label>ماه</label>
                            <input type="number" className="modal-input date-input" value={modalMonth} onChange={e=>setModalMonth(e.target.value)} placeholder="MM"/>
                        </div>
                        <div className="date-field">
                            <label>سال</label>
                            <input type="number" className="modal-input date-input" value={modalYear} onChange={e=>setModalYear(e.target.value)} placeholder="YYYY"/>
                        </div>
                    </div>
                )

                : editingField.includes("Time") ? (
                    <div className="date-inputs-container">
                        <div className="date-field">
                            <label>دقیقه</label>
                            <input type="number" max="59" className="modal-input date-input" value={modalMinute} onChange={e=>setModalMinute(e.target.value)} placeholder="MM"/>
                        </div>
                        <div className="date-field">
                            <label>ساعت</label>
                            <input type="number" max="23" className="modal-input date-input" value={modalHour} onChange={e=>setModalHour(e.target.value)} placeholder="HH"/>
                        </div>
                    </div>
                )

                : editingField.includes("Description") ? (
                    <textarea rows="4" className="modal-input" value={inputValue} onChange={e=>setInputValue(e.target.value)} placeholder="توضیحات..."/>
                ) 
                
                : (
                    <input type="text" className="modal-input" value={inputValue} onChange={e=>setInputValue(e.target.value)} placeholder="وارد کنید..." autoFocus/>
                )}

              </div>
              <div className="edit-modal-footer">
                <button type="submit" className="save-btn">تایید</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* --- Toast Notification --- */}
      <div className={`toast-notification ${toast.show ? "show" : ""} ${toast.type}`}>
        <div className="toast-icon">
            {toast.type === "success" ? <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg> 
            : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>}
        </div>
        <div className="toast-content">
            <span className="toast-title">{toast.type === "success" ? "موفق" : "خطا"}</span>
            <span className="toast-message">{toast.message}</span>
        </div>
        <div className="toast-progress"></div>
      </div>
      
    </>
  );
}